import i18n from 'i18next';

import { currentUser } from 'js/utils/user';
import Split from 'js/core_webpack/metrics/split.wjs';

export function localizationTest(testName: string): boolean {
  return (
    i18n.languages.includes('es') &&
    currentUser != null &&
    Split.pickAndRecordSharedUserAbTest(
      currentUser.id,
      'localize_frontend',
      testName,
      ['control', 'localize'],
    ) === 'localize'
  );
}

export function unrecordedLocalizationTest(): boolean {
  return (
    currentUser != null &&
    Split.unrecordedAbTest(currentUser.id, 'localize_frontend', [
      'control',
      'localize',
    ]) === 'localize'
  );
}
